import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { LabelingSpecLabel } from '../../process-plan'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { FormsModule } from '@angular/forms'
import { MatCheckbox } from '@angular/material/checkbox'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-labeling-spec-label',
  templateUrl: './labeling-spec-label.component.html',
  styleUrls: ['./labeling-spec-label.component.scss'],
  imports: [
    MatCheckbox,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class LabelingSpecLabelComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly labelSpec$ = new BehaviorSubject<LabelingSpecLabel>(null)

  @Input()
  public name: string

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set label(spec: LabelingSpecLabel) {
    this.labelSpec$.next(spec)
  }
}
